import React from 'react'

const RestaurantFormActive = props => {
	const {
		configData,
		activeStep,
		activeReservation,
		handleRemoveActiveRestaurant,
		handleContinuePayment,
	} = props

	const hotelLabels = configData.hotel.labels[0]
	return (
		<div className="bk-flow-restaurants__form-active">
			<h5>
				{
					hotelLabels &&
					hotelLabels.diningReservationDetails ? (
						hotelLabels.diningReservationDetails
					) : (
						'Reservation Details'
					)
				}
			</h5>

			<div className="bk-flow-restaurants__form-active-content">
				<p>{ hotelLabels && hotelLabels.diningContinueReservationMessage ? hotelLabels.diningContinueReservationMessage : 'Please complete your hotel booking to confirm your reservation at' } <span className="u-font-bold">{ activeReservation.name }</span>.</p>
				<p>{ hotelLabels && hotelLabels.date ? hotelLabels.date : 'Date' }: <span className="u-font-bold">{ activeReservation.date }</span></p>
				<p>{ hotelLabels && hotelLabels.time ? hotelLabels.time : 'Time' }: <span className="u-font-bold">{ activeReservation.time }</span></p>
				<p>{ hotelLabels && hotelLabels.guests ? hotelLabels.guests : 'Guests' }: <span className="u-font-bold">{ activeReservation.party }</span></p>
			</div>

			<div className="bk-flow-restaurants__form-buttons">
				<button
					className="btn btn-transparent"
					onClick={ () => handleContinuePayment(activeStep) }
				>
					{
						hotelLabels &&
						hotelLabels.continuePayment ? (
							hotelLabels.continuePayment
						) : (
							'Continue to Payment'
						)
					}
				</button>

				<button
					className="bk-flow-restaurants__form-active-back btn btn-text-only"
					onClick={ handleRemoveActiveRestaurant }
				>
					{ hotelLabels && hotelLabels.editDiningDetails ? hotelLabels.editDiningDetails : 'Edit reservation details' }
				</button>
			</div>
		</div>
	)
}

export default RestaurantFormActive



// WEBPACK FOOTER //
// ./src/components/forms/restaurantForm/elements/RestaurantFormActive.js